import * as types from './actionTypes';  
import updateOfferingReconfirmRequestApi from '../api/updateOfferingReconfirmRequestApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doUpdateOfferingReconfirmRequest(request) {

  return {
    type: types.DO_UPDATE_OFFERING_RECONFIRM_REQUEST, 
    request
  };
}

export function doUpdateOfferingReconfirmRequestRes(data) {  
  return {
    type: types.DO_UPDATE_OFFERING_RECONFIRM_REQUEST_RES, 
    data
  };
}

export function updateOfferingReconfirmRequest(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      updateOfferingReconfirmRequestApi.doUpdateOfferingReconfirmRequest(request).then(data => {
        dispatch(doUpdateOfferingReconfirmRequestRes(data));
        dispatch(doUpdateOfferingReconfirmRequestRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}